<template>
  <div class="wrapper">
    <p style="margin:3.75rpx 0rpx; text-align:center"><span style="font-family:宋体; font-size:28rpx; font-weight:bold">《</span><span
        style="font-family:宋体; font-size:28rpx; font-weight:bold">展会参观安全须知</span><span style="font-family:宋体; font-size:28rpx; font-weight:bold">》</span></p>

    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第一条 高龄老人、行动不便者须由成年人看护入馆，并全程负责其安全；醉酒者、限制行为能力者、衣履不整者谢绝入馆。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">出于安全因素的考虑，根据展馆及展会常规，本展会谢绝儿童入场参观。若您坚持携带儿童参观展会，请您务必前往主办服务台签署儿童安全承诺书，承诺在展馆内的所有时间对您携带的儿童予以充分的注意和照顾，并对该儿童的一切行为及可能发生的意外负责。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第二条 观众在参观过程中应严格遵守主办方及展馆方的安全规定，在人员密集场所应妥善注意个人安全，自觉排队、有序进出、避免拥挤，防止出现意外。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第三条 老人、孕妇、婴幼儿及患有严重心脏病、高血压、腰椎病、颈椎病等疾病的观众，应尽量避免前往人员密集场所参观，以免出现身体不适及意外损伤。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第四条 展馆内严禁吸烟和使用明火，严禁携带宠物及危险品（易燃易爆、化学品、管制刀具及其他可能危害展品和人身安全的物品等，详见禁止携带物品清单）入馆。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第五条 除婴儿车、轮椅之外，严禁携带任何代步工具（包括：电动自行车、小型摩托车、自行车、踏板车、滑板车、旱冰鞋等）入馆。携带婴儿车、轮椅的观众可就近通过展厅正门专用通道入馆。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第六条 参展观众应当文明、有序参观，参观时请勿大声喧哗，请勿擅自使用展馆内电源。参观时不得私自进入非参观区域并要服从工作人员的疏导；场馆内请勿奔跑、追逐、打闹、攀爬、躺卧；严禁翻越围挡护栏、请自觉爱护展览设施、服务设施，如造成损坏，须照价赔偿并承担相应的法律责任。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第七条 参展观众应妥善看管自身财物，一旦发生丢失或被窃，可拨打110报警。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第八条 参展观众请听从工作人员引导，协助我们维持好展馆内的参观秩序和良好的参观环境。如遇突发事件，观众应当听从工作人员的疏导，按照应急标识、广播等，从应急通道迅速撤离。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第九条 参展观众应当自觉爱护展品，严格按照展品说明进行操作，如因违规操作造成展品损坏，需照价赔偿；造成人身伤害或财产损失的，由观众自行承担。</span></p>
    <p style="margin:3.75rpx 0rpx; text-indent:2em"><span style="font-family:宋体; font-size:28rpx">第十条 参展观众不得随意触动馆内消防警报、电源开关等设施设备，因观众的不规范行为或监护人员监护不力造成安全事故的，由行为人或监护人自行负责。</span></p>
  </div>
</template>

<script>
export default {
  data(){
    return {
      left:'<',
      right:'>'
    }
  },
  onLoad(){
   
  }
};
</script>

<style>
.wrapper {
  padding: 16px 15px;
  color: #241f1f;
  line-height: 25px;
}
h3 {
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  margin-bottom: 18px;
}
h4 {
  font-weight: bold;
  font-size: 13px;
  margin-top: 18px;
  margin-bottom: 10px;
}
/* view {
  font-size: 24upx;
  line-height: 32upx;
  text-indent: 48upx;
  text-align: justify;
  margin-bottom: 10upx;
} */
.thick {
  font-weight: bold;
}
.btm {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0px -2px 4px 0px rgba(219, 219, 219, 0.5);
}
.btm button {
  width: 1920px;
  height: 37px;
  line-height: 37px;
  background-color: #00B8E0;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/safety/safety.vue